import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CourseCategoryItem from '../CourseCategoryItem/CourseCategoryItem'
import './CourseCategory.css'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import { shuffle } from 'lodash';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { useEffect, useState } from 'react';
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration';
import { Link } from 'react-router-dom';
export default function CourseCategory() {
    const colors = ['linear-gradient(180deg, #AAE181 0%, #89D351 100%)', 'linear-gradient(180deg, #FECF6C 0%, #FFBE70 100%);', 'linear-gradient(180deg, #AB8EFF 0%, #7443FF 100%)', 'linear-gradient(180deg, #FFB08D 0%, #FF905F 100%)', 'linear-gradient(180deg, #AAE181 0%, #89D351 100%)', 'linear-gradient(180deg, #FFB08D 0%, #FF905F 100%)', 'linear-gradient(180deg, #AB8EFF 0%, #7443FF 100%)'];
    const shuffledColors = shuffle(colors);
    const [categoryList, setCategoryList] = useState([]);
    useEffect(() => {
        axiosConfig.get("api/Categories?categoryType=0&pageSize=6").then((result) => {
            setCategoryList(result.data);
        })
    }, [])
    return (
        <>
            <div className='course-category-section'>
                <div className='course-category'>
                    <Container>
                        <Row>
                            {
                                categoryList?.map((item, index) => (
                                    <Col xs={6} md={4} lg={2} key={item.id}>
                                        <Link to={"/search/all/" + item.title}>
                                            <CourseCategoryItem item={item} backgroundColor={shuffledColors[index]} />
                                        </Link>
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                </div>
            </div>
            <div className='course-category-responsive'>
                <div className='course-category'>
                    <Container>
                        <Swiper
                            slidesPerView={2}
                            spaceBetween={10}
                            autoplay={{
                                delay: 3500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                    spaceBetween: 20,
                                },
                                300: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 40,
                                },
                                992: {
                                    slidesPerView: 3,
                                    spaceBetween: 40,
                                },
                            }}
                            modules={[Autoplay]}
                            className="mySwiper"
                        >
                            {
                                categoryList?.map((item, index) => (
                                    <SwiperSlide key={item.id}>
                                        <Link to={"/search/all/" + item.title}>

                                            <CourseCategoryItem item={item} backgroundColor={shuffledColors[index]} />
                                        </Link>
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    </Container>
                </div>
            </div>

        </>

    )
}
